import React from 'react';
import PropTypes from 'prop-types';
import ProfilePic from "../../ProfilePic";
import assets from "../../../util/assets";
import {getStatus} from "../../../util/utility";
import "./index.css";

NewChatUserListItem.propTypes = {
    action: PropTypes.func.isRequired,
    profile_pic: PropTypes.string.isRequired,
    username: PropTypes.string.isRequired,
    status: PropTypes.number.isRequired,
    item: PropTypes.object.isRequired,
};

NewChatUserListItem.defaultProps = {
    profile_pic: assets.user_placeholder,
    username: 'username',
    status: 0,
}

const getUserType = (props) => {
    return props.item.broadcaster_id === null ? "user" : "broadcaster"
}

function NewChatUserListItem(props) {
    return (
        <div className="new-chat-user-list-item display-flex-align-center cursor-pointer" onClick={() => {
            props.action(props.item)
        }}>
            <ProfilePic
                profile_pic={props.profile_pic}
                is_verified={props.item.is_broadcaster_verified}
                user_type={getUserType(props)}/>

            <div className="new-chat-display-flex-justify-content-flex-start">
                <div className="broadcaster-profile-container-broadcaster-name">
                    <span className="new-chat-username">{props.username}</span>
                    <img src={getStatus(props.status)} style={{paddingLeft: 5}}
                         alt="user status"/>
                </div>
                {getUserType(props) === "broadcaster" && props.type !== "user" && <div className="new-chat-user-type">Broadcaster</div>}
            </div>
        </div>
    );
}

export default NewChatUserListItem;